import _ from "lodash";
import React from "react";
import { useI18n } from "Hooks";
import { Button, Modal } from "@toddle-edu/ds-web";
import Loading from "UIComponents/Loading";

const styles = {
  header: {},
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
  },
  loaderOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
};

const AIPanelDialogs = props => {
  const { t } = useI18n();
  const {
    type = null,
    testId = "",
    body = null,
    title = null,
    loading = false,
    onClose = _.noop,
    onSubmit = _.noop,
    showHeader = true,
    showFooter = true,
    hasHeaderSeparator = false,
    hasFooterSeparator = false,
    buttonText = t("common:untitled"),
  } = props;

  if (!type) return null;

  return (
    <Modal
      isOpen={true}
      width={"440px"}
      onClose={onClose}
      height={"fit-content"}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={false}
    >
      {showHeader && (
        <Modal.Header
          isClosable={true}
          style={styles.header}
          hasSeparator={hasHeaderSeparator}
        >
          {title ? title : null}
        </Modal.Header>
      )}
      {body && <Modal.Body isScrollable>{body}</Modal.Body>}
      {showFooter && (
        <Modal.Footer style={styles.footer} hasSeparator={hasFooterSeparator}>
          <Button
            size="medium"
            dsVersion="2.0"
            type="outlined"
            variant="neutral"
            onClick={onClose}
            disabled={loading}
            testId={`${testId}-close-button`}
          >
            {t("common:cancel")}
          </Button>
          <Button
            type="fill"
            size="medium"
            dsVersion="2.0"
            disabled={loading}
            variant="progressive"
            onClick={() => onSubmit(type)}
            testId={`${testId}-submit-button`}
          >
            {buttonText}
          </Button>
        </Modal.Footer>
      )}
      {loading && <Loading containerStyle={styles.loaderOverlay} />}
    </Modal>
  );
};

export default AIPanelDialogs;
